import { createSlice } from "@reduxjs/toolkit";

export const customStocksSlice = createSlice({
  name: "customStocks",
  initialState: {
    data: [],
    currentCustomStock: null,
    selectedModal: null,
  },
  reducers: {
    addCustomStock: (state, action) => {
      state.data.push(action.payload);
    },
    setData: (state, action) => {
      state.data = action.payload;
      state.init = true;
    },
    setSelectedModal: (state, action) => {
      state.selectedModal = action.payload;
    },
    setCurrentCustomStock: (state, action) => {
      state.currentCustomStock = action.payload;
    },
    updateCustomStock: (state, action) => {
      const { id } = action.payload;
      const index = state.data.findIndex((item) => item.id === id);
      if (index !== -1) {
        state.data[index] = action.payload;
      }
    },
    deleteCustomStock: (state, action) => {
      const { id } = action.payload;
      state.data = state.data.filter((item) => item.id !== id);
    },
  },
});

export const {
  addCustomStock,
  setData,
  setSelectedModal,
  setCurrentCustomStock,
  updateCustomStock,
  deleteCustomStock,
} = customStocksSlice.actions;

export default customStocksSlice.reducer;
